import { dictionarySection } from "@/content/i18n/dictionaries";
import type { Locale } from "@/lib/i18n/config";

type LegalContent = {
  ui: {
    backToHomeLabel: string;
    lastUpdatedPrefix: string;
    translationFallbackNotice: string;
  };
  privacy: {
    eyebrow: string;
    title: string;
    lastUpdated: string;
  };
  terms: {
    eyebrow: string;
    title: string;
    lastUpdated: string;
  };
  cookies: {
    eyebrow: string;
    title: string;
    lastUpdated: string;
  };
  legalNotice: {
    eyebrow: string;
    title: string;
    lastUpdated: string;
    intro: string;
    providerTitle: string;
    provider: {
      companyLabel: string;
      company: string;
      vatLabel: string;
      vat: string;
      lines: string[];
      phoneLabel: string;
      phone: string;
      phoneHref: string;
      emailLabel: string;
      email: string;
      emailHref: string;
    };
    activityTitle: string;
    activityBody: string;
    applicableTermsTitle: string;
    applicableTermsBodyPrefix: string;
    applicableTermsClosingPrefix: string;
    contactClosingPrefix: string;
  };
  doNotSell: {
    eyebrow: string;
    title: string;
    lastUpdated: string;
    intro: string;
    saleTitle: string;
    saleBody: string;
    gpcTitle: string;
    gpcBody: string;
    gpcDetected: string;
    gpcNotDetected: string;
    optOutButton: string;
    optedOut: string;
    emailPrefix: string;
    emailSubject: string;
    emailSuffix: string;
    prefsPrefix: string;
    prefsLabel: string;
    privacyPrefix: string;
    privacyLabel: string;
  };
  hub: {
    eyebrow: string;
    title: string;
    intro: string;
    documentsTitle: string;
    documentsBody: string;
    companyIdentity: {
      title: string;
      subtitle: string;
      legalNameLabel: string;
      cifLabel: string;
      vatLabel: string;
      addressLabel: string;
      supportLabel: string;
      privacyLabel: string;
    };
    rightsTitle: string;
    rightsIntro: string;
    rightsItems: string[];
    rightsContactPrefix: string;
    rightsEmail: string;
    rightsAppSuffix: string;
    aepdPrefix: string;
    aepdLabel: string;
    aepdUrl: string;
  };
};

export function getLegalContent(locale: Locale): LegalContent {
  return dictionarySection(locale, "legal") as LegalContent;
}
